package com.appsyde.shared.modules.ai.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DetectedFieldV2(
    val key: String? = null,
    val label: String? = null,
    val value: String? = null,
    val status: String? = null,
    /** Source for badge: "agent_entered" → Saisi, "agent_confirmed" → Validé. */
    val source: String? = null
)

@Serializable
data class MissingFieldV2(
    val key: String? = null,
    val label: String? = null,
    val required: Boolean? = null,
    val reason: String? = null
)

@Serializable
data class ToConfirmFieldV2(
    val key: String? = null,
    val label: String? = null,
    val reason: String? = null
)
